import React, { Component } from 'react';
import { Grid, Form, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ChargesAndPrepaymentsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { YesNoOptions } from 'Common/FormHelper';
import {
  updateStatus,
  toggleAllStatuses,
} from '../state/chargesandprepaymentsreport/actions';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

class ChargesAndPrepaymentsReportFormContainer extends Component {
  StatusOptions = Object.values(StatusEnum).reduce((carry, option) => {
    if (option !== '0') {
      carry.push(Number(option));
    }
    return carry;
  }, []);

  areAllStatusesChecked() {
    return this.props.statuses.length === this.StatusOptions.length;
  }

  render() {
    const { loading } = this.props;

    return (
      <Form name={CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Field
                name={Fields.User}
                component={SelectField}
                type="text"
                label="User"
                options={this.props.userOptions}
                disabled={loading}
                className={'short'}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={5}>
              <Field
                label={'From Date'}
                name={Fields.FromDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
                disabled={loading}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                label={'To Date'}
                name={Fields.ToDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
                disabled={loading}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column className="input-group--btn-group">
              <ReduxFormButtonGroup
                label={'Adjustments Only?'}
                options={YesNoOptions}
                formName={CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME}
                fieldName={Fields.AdjustmentsOnly}
                disabled={loading}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column className="field">
              <label className={'p-b-0'}>status</label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={1}>
              <Checkbox
                name={Fields.Statuses + '-All'}
                label={'All'}
                checked={this.areAllStatusesChecked()}
                onChange={(e, data) => {
                  this.props.toggleAllStatuses();
                }}
              />
            </Grid.Column>
            {this.StatusOptions.map((option, index) => {
              return (
                <Grid.Column width={1} key={index}>
                  <Checkbox
                    name={Fields.Statuses + '-' + option}
                    label={option}
                    checked={this.props.statuses.some(
                      status => status === option
                    )}
                    onChange={(e, data) => {
                      this.props.updateStatus(option, data.checked);
                    }}
                  />
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }
  if (moment(values[Fields.ToDate]).isBefore(moment(values[Fields.FromDate]))) {
    errors[Fields.ToDate] = 'To Date must be after From Date.';
  }
  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }

  if (!values[Fields.User] && values[Fields.User] !== 0) {
    errors[Fields.User] = 'User must be set.';
  }
  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: state.form[CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME].values,
    statuses:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport
        .statuses,
    loading:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport
        .loading,
  };
};

const ChargesAndPrepaymentsReportForm = reduxForm({
  form: CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(mapStateToProps, { updateStatus, toggleAllStatuses })(
      ChargesAndPrepaymentsReportFormContainer
    )
  )
);

export { ChargesAndPrepaymentsReportForm };



// WEBPACK FOOTER //
// ./src/pages/chargesandprepaymentsreport/components/ChargesAndPrepaymentsReportForm.js